import { t as translate } from 'i18next';
import { Alert } from './alert.web';
import type { CvConflictChoice, CvWriteKind } from './cv-write-coordinator';
import { CV_CONFLICT_COPY_KEYS } from './cv-write-policy';

/**
 * B02, web twin of cv-conflict-prompt.ts: the in-app dialog (CLAUDE.md rule
 * 8, never a browser dialog). Escape and the backdrop press "Keep editing",
 * which never discards and never overwrites.
 */
export function promptCvRevisionConflict(kind: CvWriteKind): Promise<CvConflictChoice> {
  const t = (key: string) => translate(key, { ns: 'seeker' });
  return new Promise<CvConflictChoice>((resolve) => {
    let settled = false;
    const finish = (choice: CvConflictChoice) => {
      if (settled) return;
      settled = true;
      resolve(choice);
    };
    Alert.alert(
      t(CV_CONFLICT_COPY_KEYS.title),
      t(CV_CONFLICT_COPY_KEYS.message[kind]),
      [
        { text: t(CV_CONFLICT_COPY_KEYS.keep), style: 'cancel', onPress: () => finish('keep') },
        {
          text: t(CV_CONFLICT_COPY_KEYS.discard),
          style: 'destructive',
          onPress: () => finish('discard'),
        },
        {
          text: t(CV_CONFLICT_COPY_KEYS.apply),
          style: 'default',
          isPreferred: true,
          onPress: () => finish('apply'),
        },
      ],
      { cancelable: true, onDismiss: () => finish('keep') },
    );
  });
}
